
import { useState } from "react";
import { MessageCircle } from "lucide-react";

interface PainPoint {
  title: string;
  description: string;
}

interface HeroQuestionsProps {
  painPoints: PainPoint[];
  visible: boolean;
}

export function HeroQuestions({ painPoints, visible }: HeroQuestionsProps) {
  const [hoveredQuestion, setHoveredQuestion] = useState<number | null>(null);

  return (
    <div 
      className={`max-w-2xl mx-auto mt-14 md:mt-18 border-t border-charcoal/10 pt-10 md:pt-14 opacity-0 ${visible ? "animate-fade-in" : ""}`}
      style={{ animationDelay: "1300ms", animationDuration: "1s" }}
    >
      <h3 className="text-xl sm:text-2xl md:text-4xl font-serif italic text-charcoal/90 mb-6 md:mb-8 px-4 sm:px-0">
        Is this what success was supposed to feel like?
      </h3>
      <p className="text-base sm:text-lg md:text-xl text-charcoal/80 mb-6 md:mb-8 max-w-xl mx-auto px-4 sm:px-0">
        You've achieved what others dream of.
        <br />
        Yet in quiet moments, questions surface:
      </p>
      
      <div className="space-y-6 md:space-y-8 text-left max-w-lg mx-auto bg-[#F6F6F7] p-5 sm:p-6 md:p-8 rounded-sm shadow-sm mx-3 sm:mx-auto">
        <div className="flex items-center">
          <MessageCircle className="h-5 w-5 text-charcoal/40 mr-2" />
          <h2 className="text-xl sm:text-2xl mb-0 font-serif">The Questions That Keep You Awake</h2>
        </div>
        
        {painPoints.map((point, index) => (
          <div 
            key={index} 
            className="transition-all duration-300 transform hover:scale-102"
            onMouseEnter={() => setHoveredQuestion(index)}
            onMouseLeave={() => setHoveredQuestion(null)}
          >
            <div className="flex items-start">
              <div className="mr-5 pt-1">
                <div className={`w-[1px] h-6 bg-charcoal/40 transition-all duration-300 ${hoveredQuestion === index ? 'h-8 bg-charcoal/60' : ''}`}></div>
              </div>
              <div className={`transition-all duration-300 ${hoveredQuestion === index ? 'transform translate-x-[2px]' : ''}`}>
                <h3 className="text-lg sm:text-xl font-medium mb-2">{point.title}</h3>
                <p className="text-base sm:text-lg font-light text-charcoal/80 leading-relaxed">{point.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
